import { Button } from "@dash/form";
import { Card, Header4 } from "@dash/page";
import React from "react";
import { MdSync } from "react-icons/md";
import { useNavigate } from "react-router-dom-v5-compat";

export const ItemSyncOptionsBar: React.FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <div css={{ display: "flex", gap: "1rem", flexDirection: "row", alignItems: "center", flexWrap: "wrap" }}>
      <OptionCard label="Google Sheets">
        <Button
          variant="outline"
          icon={<MdSync />}
          onClick={() => navigate(`/crm/items/sync/sheetsItem`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Diff
        </Button>
      </OptionCard>
      <OptionCard label="Business Central">
        <Button
          variant="outline"
          icon={<MdSync />}
          onClick={() => navigate(`/crm/items/sync/bcItem`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Diff
        </Button>
      </OptionCard>
      <OptionCard label="Shopify">
        <Button
          variant="outline"
          icon={<MdSync />}
          onClick={() => navigate(`/crm/items/sync/shopifyProduct`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Diff produkty
        </Button>
        <Button
          variant="outline"
          icon={<MdSync />}
          onClick={() => navigate(`/crm/items/sync/shopifyVariant`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Diff warianty
        </Button>
      </OptionCard>
    </div>
  );
};

const OptionCard = (props: { label: string; children?: React.ReactNode }) => {
  return (
    <Card
      variant="secondary"
      css={{ flexDirection: "column", justifyContent: "space-between", flexGrow: 0, gap: "1rem" }}
    >
      <Header4>{props.label}</Header4>
      <div css={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>{props.children}</div>
    </Card>
  );
};
